import React, { Fragment, useContext } from 'react'
// import { Link } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { ThemeContext } from '../components/ThemeContext.js'

const About = () => {
  const { theme } = useContext(ThemeContext)
  return (
    <Fragment>
      <div className='about' style={{ color: theme.text }}>
        <div className='div1'>
          <h3>
            <strong>About Us</strong>
          </h3>
          <p>
            Our company produces electronic receipt software for point of sale
            systems.
          </p>
          <p>
            The idea came about from seeing how many receipts after a purchase
            end up in the trash, directly to the waste stream.
          </p>
          <p>
            With a scan of your personal QR code you will receive an electronic
            receipt at the time of purchase. By creating an account you can
            search, print receipts and more.
          </p>
          <p>
            The QR code triggers software which connects with your individual
            account and transmits the electronic version of the receipt to you.
          </p>
          <p>
            You can become a member by creating your account with us. When you
            create your account you will get assigned a unique QR code to use at
            checkout.
          </p>

          <h4>Business can use technology that enables:</h4>

          <ul style={{ listStyleType: 'none' }}>
            <li>
              <FontAwesomeIcon icon={faCheckCircle} /> Contactless checkout
            </li>
            <li>
              <FontAwesomeIcon icon={faCheckCircle} /> Elimination of the need
              for paper and ink
            </li>
            <li>
              <FontAwesomeIcon icon={faCheckCircle} /> Reduced fraud
            </li>
            <li>
              <FontAwesomeIcon icon={faCheckCircle} /> Customizable receipts at
              checkout
            </li>
          </ul>

          <Button
            size='sm'
            as='a'
            variant='outline-primary'
            href='mailto:info@globalreceipt.com'
            style={{
              borderColor: theme.accent,
              color: theme.accent,
              backgroundColor: 'transparent',
              border: `1px solid ${theme.accent}`
            }}
          >
            Contact Us
          </Button>
        </div>
      </div>
    </Fragment>
  )
}

export default About
